import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import * as Endpoints from "../../entities/Endpoints";

export const fetchPreferencesAllergies = createAsyncThunk(
  "preferencesAllergies/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        Endpoints.GET_ALL_PREFERENCES_ALLERGIES
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch preferences and allergies"
      );
    }
  }
);

const preferencesAllergiesSlice = createSlice({
  name: "preferencesAllergies",
  initialState: {
    preferences: [],
    allergies: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreferencesAllergies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPreferencesAllergies.fulfilled, (state, action) => {
        state.loading = false;
        state.preferences = action.payload.preferences;
        state.allergies = action.payload.allergies;
      })
      .addCase(fetchPreferencesAllergies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default preferencesAllergiesSlice.reducer;
